module.exports = __webpack_public_path__ + "img/ad-02.91158328.png";